import { firebase } from 'utils'

export const sendImproveProfileEmail = firebase
  .functions()
  .httpsCallable('sendImproveProfileEmail')
